// EHR-launch onboarding profile api fns — carved verbatim from
// `src/api/scribeAPIV2.ts` (which now re-exports them) as D1 of the
// `integrations/ehr` family (ARCFE-1087). Bodies are byte-identical to the hub
// apart from the transport accessor: `scribeHttpV2.` -> `http().`.
import type {
  CreateUserEHRLaunchProfileAPIV2Request,
  CreateUserEHRLaunchProfileAPIV2Response,
  GetUserEHRLaunchProfileResponse,
  GetUserEHRLaunchProfileV2Response,
  UpdateUserEHRLaunchProfileV2Request,
  UpdateUserEHRLaunchProfileV2Response,
} from '../../contracts/types';
import { http } from './ehrHttp';

import type { EHRProvider } from '@heidi/schema/ml-scribe';

export const connectIntegrationEhrLaunch = (
  payload: CreateUserEHRLaunchProfileAPIV2Request
) => {
  return http().post<CreateUserEHRLaunchProfileAPIV2Response>(
    '/ehr-launch/onboarding/user-ehr-launch-profile/v2',
    payload
  );
};

export const updateIntegrationEhrLaunch = (
  payload: UpdateUserEHRLaunchProfileV2Request,
  ehrProvider: EHRProvider
) => {
  return http().patch<UpdateUserEHRLaunchProfileV2Response>(
    `/ehr-launch/onboarding/user-ehr-launch-profile/${ehrProvider}`,
    payload
  );
};

export const deleteIntegrationEhrLaunch = (profileName: string) => {
  return http().delete(`/ehr-launch/onboarding/user-ehr-launch-profile/${profileName}`);
};

export const getUserEHRLaunchProfile = () => {
  return http().get<GetUserEHRLaunchProfileV2Response>(
    '/ehr-launch/onboarding/user-ehr-launch-profile/v2'
  );
};

export const getUserEHRLaunchProfileAuth0 = () => {
  return http().get<GetUserEHRLaunchProfileResponse>(
    '/ehr-launch/onboarding/user-ehr-launch-profile'
  );
};
